import { AxiosResponse } from 'axios'

export const isSuccessResponse = <T = any>(response: AxiosResponse<T> | AxiosResponse<any>): response is AxiosResponse<T> => {
  return (response as AxiosResponse<T>).status.toString().startsWith('20')
}
